module.exports = __webpack_public_path__ + "static/media/image.0eda9de3.svg";